import type {
  AlbumTypeEnumEnum,
  TagContentTypeEnumEnum,
  TrackTypeEnumEnum,
} from '@/shared/api'
import { type PresetColorType } from 'antd/es/_util/colors'

export const AlbumTypeEnum = {
  Music: 1 as AlbumTypeEnumEnum,
  Podcast: 2 as AlbumTypeEnumEnum,
  AudioBook: 3 as AlbumTypeEnumEnum,
  Sermon: 4 as AlbumTypeEnumEnum,
} as const

export const AlbumTypeTrackTypeMatchEnum = {
  [AlbumTypeEnum.Music]: 1 as TrackTypeEnumEnum,
  [AlbumTypeEnum.Podcast]: 2 as TrackTypeEnumEnum,
  [AlbumTypeEnum.Sermon]: 3 as TrackTypeEnumEnum,
  [AlbumTypeEnum.AudioBook]: 4 as TrackTypeEnumEnum,
} as const

export const AlbumTypeTagContentTypeMatchEnum = {
  [AlbumTypeEnum.Music]: 1 as TagContentTypeEnumEnum,
  [AlbumTypeEnum.Podcast]: 2 as TagContentTypeEnumEnum,
  [AlbumTypeEnum.AudioBook]: 3 as TagContentTypeEnumEnum,
}

export type AlbumTypeEnum = (typeof AlbumTypeEnum)[keyof typeof AlbumTypeEnum]

export const albumTypeArray = Object.values(AlbumTypeEnum)

export const getAlbumTypeString = (type: AlbumTypeEnum) => {
  switch (type) {
    case AlbumTypeEnum.Music:
      return 'Музыка'
    case AlbumTypeEnum.Podcast:
      return 'Подкасты'
    case AlbumTypeEnum.AudioBook:
      return 'Аудиокниги'
    case AlbumTypeEnum.Sermon:
      return 'Проповеди'
    default:
      return 'Неизвестный тип'
  }
}

export const getAlbumTypeColor = (type: AlbumTypeEnum): PresetColorType => {
  switch (type) {
    case AlbumTypeEnum.Music:
      return 'purple'
    case AlbumTypeEnum.Podcast:
      return 'pink'
    case AlbumTypeEnum.AudioBook:
      return 'blue'
    case AlbumTypeEnum.Sermon:
      return 'orange'
    default:
      return 'cyan'
  }
}
